<div style="display: flex; align-items: center; justify-content: center">
  <span
    class="material-icons wpd-icon text-transparent bg-clip-text bg-gradient-to-r"
    *ngIf="_icon"
    [ngClass]="{
      'ddc-text-gradient-light-1': _isLightTheme && _type == '1',
      'ddc-text-gradient-dark-1': _isDarkTheme && _type == '1',
      'ddc-text-gradient-paper-1': _isPaperTheme && _type == '1',
      'ddc-text-gradient-light-2': _isLightTheme && _type == '2',
      'ddc-text-gradient-dark-2': _isDarkTheme && _type == '2',
      'ddc-text-gradient-paper-2': _isPaperTheme && _type == '2',
    }"
  >
    {{ _icon }}
  </span>
  <span
    class="text-transparent bg-clip-text bg-gradient-to-r"
    *ngIf="_text"
    [ngClass]="{
      'ddc-text-gradient-light-1': _isLightTheme && _type == '1',
      'ddc-text-gradient-dark-1': _isDarkTheme && _type == '1',
      'ddc-text-gradient-paper-1': _isPaperTheme && _type == '1',
      'ddc-text-gradient-light-2': _isLightTheme && _type == '2',
      'ddc-text-gradient-dark-2': _isDarkTheme && _type == '2',
      'ddc-text-gradient-paper-2': _isPaperTheme && _type == '2',
    }"
  >
    {{ _text }}
  </span>
</div>
